import React, { useState, useEffect } from 'react'

export const useTypewriter = (
  text: string | React.ReactNode,
  options: { delay?: number; onComplete?: () => void } = {},
) => {
  const [displayText, setDisplayText] = useState('')
  const [isComplete, setIsComplete] = useState(false)
  const { delay = 5, onComplete } = options

  useEffect(() => {
    let timeoutId: NodeJS.Timeout
    let currentIndex = 0
    setIsComplete(false)

    const type = () => {
      if (typeof text === 'string' && currentIndex < text.length) {
        setDisplayText(text.substring(0, currentIndex + 1))
        currentIndex++
        timeoutId = setTimeout(type, delay)
      } else {
        setIsComplete(true)
        if (onComplete) {
          onComplete()
        }
      }
    }

    type()

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [text, delay, onComplete])

  return { displayText, isComplete }
}
